import { render, staticRenderFns } from "./addTask.vue?vue&type=template&id=67506e9d&"
import script from "./addTask.vue?vue&type=script&lang=js&"
export * from "./addTask.vue?vue&type=script&lang=js&"
import style0 from "./addTask.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "addTask.vue"
export default component.exports